import { useRef } from 'react'

import {
  type ContactFormState,
  useInitContactFormState,
} from '../../contact-form'
import { useApiOrdersSwrGetOrders } from '../../order'
import { useDirectFormDialogContext } from '../components/DirectContactFormDialog/DirectContactFormDialogContext'

export const useDirectContactFormFormStateWithOnlySubOrderInitialization =
  (): ContactFormState => {
    const { data } = useApiOrdersSwrGetOrders()
    const { product, subject } = useDirectFormDialogContext()

    const initSubOrderNumber =
      data?.orders && data.orders.length > 0 ? '' : undefined

    const formStateRef = useRef(
      useInitContactFormState({
        formSubject: subject,
        product,
        subOrderNumber: initSubOrderNumber,
      }).formState,
    )

    return formStateRef.current
  }
